<template>
  <div class="monitoring">
    <page-list-container :total="total" :pageSize="pageSize" :inputCurrentPage="currentPage" @onPageChange="onPageChange" @onSizeChange="onSizeChange">
      <div>
        <nested-monitoring-table 
          :dataArray="dataArray" 
          :selectedIndex="selectedIndex"
          @onRowSelect="onRowSelect">
        </nested-monitoring-table>
      </div>
    </page-list-container>
  </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import NestedMonitoringTable from "@c/operation-log/monitoring-data/nested-monitoring-table.vue";
import { DateTool } from "@js/date-tool.js";
export default {
  components: {
    PageListContainer,
    NestedMonitoringTable,
  },

  props: {
    duration: Object,
  },

  data() {
    return {
      // 搜索
      startTime: 0,
      endTime: 0,
      deviceSn: "",
      //列表
      dataArray: [],
      total: 0,
      pageSize: undefined,
      currentPage: 1,
      selectedModel: null,
      selectedIndex: null
    };
  },

  computed: {
    hospitalID() {
      return this.$store.state.selectedHospital.hospitalid;
    },
  },

  watch: {
    hospitalID() {
      this.currentPage = 1;
      this.getM11bMonitoringDataList();
    },

    duration() {
      this.startTime = this.duration.startTime;
      this.endTime = this.duration.endTime;
      this.currentPage = 1;
      this.getM11bMonitoringDataList();
    },
  },

  mounted() {
    this.pageSize = bestPageSizeComputer()
    this.getM11bMonitoringDataList();
  },

  methods: {
    //分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.getM11bMonitoringDataList();
    },

    onSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.getM11bMonitoringDataList();
    },
    
    // action
    // 搜索
    onDurationSelected(startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      this.currentPage = 1;
      this.getM11bMonitoringDataList();
    },

    onSearchClick(deviceSn) {
      this.deviceSn = deviceSn
      this.currentPage = 1;
      this.getM11bMonitoringDataList();
    },

    //row selection
    onRowSelect: function (index) {
      this.selectedIndex = index;
      // 可以根据需要解析index来获取具体的设备信息
      const [mainIndex, boundIndex] = index.split('-').map(Number);
      if (this.dataArray[mainIndex] && this.dataArray[mainIndex].boundDevices[boundIndex]) {
        this.selectedModel = this.dataArray[mainIndex].boundDevices[boundIndex];
      }
    },

    //分页
    onPagination: function (currentPage) {
      this.currentPage = currentPage;
      this.getM11bMonitoringDataList();
    },

    // method
    async getM11bMonitoringDataList() {
      this.selectedIndex = null;
      this.selectedModel = null;
      try {
        const params = {
          "deviceSn": this.deviceSn,
          "pageNum": this.currentPage,
          "pageSize": this.pageSize,
          "startTime": DateTool.timestampToStr(this.startTime, 'Y-M-D h:m:s'),
          "endTime": DateTool.timestampToStr(this.endTime, 'Y-M-D h:m:s')
        };
        
        // // 暂时使用静态数据模拟
        // const mockData = {
        //   list: [
        //     {
        //       deviceSn: "M11B231200009 Pro+",
        //       monitorStatus: 1,
        //       gmtCreate: "2025/10/20 6:02",
        //       boundDevices: [
        //         {
        //           typeName: "血氧波",
        //           sn: "M11B231200009",
        //           connectState: 1,
        //           powerStatus: 0,
        //           heartRate: 27,
        //           spo: null,
        //           swVersion: "2.4.12562"
        //         },
        //         {
        //           typeName: "血氧指环",
        //           sn: "OXM223120005",
        //           connectState: 2,
        //           powerStatus: 2,
        //           heartRate: null,
        //           spo: 98.83,
        //           swVersion: "2.4.12562"
        //         },
        //         {
        //           typeName: "脑电",
        //           sn: "EEG-223120034",
        //           connectState: 2,
        //           powerStatus: 3,
        //           heartRate: null,
        //           spo: null,
        //           swVersion: "2.4.12562"
        //         },
        //         {
        //           typeName: "心电",
        //           sn: "ECG-223126701",
        //           connectState: 2,
        //           powerStatus: 1,
        //           heartRate: null,
        //           spo: null,
        //           swVersion: "2.4.12562"
        //         },
        //         {
        //           typeName: "鼻气流",
        //           sn: "P12A-223125656",
        //           connectState: 2,
        //           powerStatus: 4,
        //           heartRate: null,
        //           spo: null,
        //           swVersion: "2.4.12562"
        //         }
        //       ]
        //     },
          
        //   ],
        //   total: 1
        // };
        
        // 保持原始的嵌套结构
        // this.dataArray = mockData.list;
        // this.total = mockData.list.length;
        
        // 正式接口调用（暂时注释）
        const data = await this.$api.getMonitoringList(params);
        this.dataArray = data.list;
        console.log('this.dataArray',this.dataArray)
        this.total = data.total;
      } catch (error) {
        this.$toast.showRed(error);
      }

    },
  },
};
</script>


<style lang="scss" scoped>
.monitoring {
  font-size: 19px;
  width: 100%;
}
</style>